// extracted by mini-css-extract-plugin
module.exports = {"cls1":"SideNavigationPanel-module--cls1--i9crT","cls2":"SideNavigationPanel-module--cls2--1Afsn SideNavigationPanel-module--cls1--i9crT"};